"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSSOTokenDetails = void 0;

function getSSOTokenDetails(token) {
  try {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  } catch (error) {
    console.info("SSO token could not be parsed: ".concat(error));
    return null;
  }
}

exports.getSSOTokenDetails = getSSOTokenDetails;